/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Vue, Component } from 'vue-property-decorator';
import { Cell, CellGroup } from 'vant';
import platform from '@/shared/utils/platform';
import { RouterV2Enum } from '@/router/router-names';
import { openThirdPage } from '@/api/native/utils';

const style: Dictionary = require('./index.module.scss');

type CellDataType = {
  // 标题
  title: string;
  // 点击直接跳转
  url: string;
  // 点击处理事件
  onClick?: (item: CellDataType) => void;
};

@Component
export default class AboutUsList extends Vue {
  private data: CellDataType[] = [
    {
      title: '了解我们',
      url: RouterV2Enum.aboutUs,
    },
  ];

  private render() {
    return (
      <CellGroup>
        {this.data.map((item) => (
          <Cell
            title={item.title}
            isLink
            onClick={this.onCellItemClick.bind(this, item)}
          >
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
        ))}
      </CellGroup>
    );
  }

  private onCellItemClick(item: CellDataType) {
    if (typeof item.onClick === 'function') {
      item.onClick(item);
    } else if (item.url) {
      // 是否是臻有钱自身的url
      if (item.url && !/^http(s?):\/\//.test(item.url)) {
        this.$router.push({
          path: item.url,
        });
      } else if (platform.isHelloApp) {
        openThirdPage(item.url);
      } else {
        window.location.href = item.url;
      }
    }
  }
}
